import { FC } from "react";
import ErrorView from "@/components/ErrorView";

const NotFoundProjectView: FC = (): JSX.Element => {
  return (
    <ErrorView>
      <span>投稿されたプロジェクトはありません</span>
    </ErrorView>
  );
};

export default NotFoundProjectView;
